module.exports = __webpack_public_path__ + "asset/img/left.5e73f5d1.png";